import React from "react";
import {
  Card,
  CardContent,
  Stack,
  Tooltip,
  styled,
  tooltipClasses,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import "./IconVisualizationCard.css";
import { Box } from "@mantine/core";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

export const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    fontSize: theme.typography.pxToRem(16),
  },
}));

const percentageDescription =
  "Percentage change is relative to the previous month";

const noPercentage = 
  "Percent change is not available if the current or previous month's value is not available or zero."

const IconVisualizationCard = ({
  label,
  iconName,
  item,
  percentageChange,
  description,
}) => {
  const value = item[label];
  const formattedValue = (value !== null && value !== undefined && !isNaN(value))
    ? new Intl.NumberFormat().format(value)
    : '-';

  const program = item["Program"];
  const isMainCard =
    program === "Conflict Resolution Program" && label === "Total Members";

  const handlePercentageChange = (percentageChange) => {
    if (percentageChange > 0) {
      return (
        <HtmlTooltip title={percentageDescription} placement="right-start">
          <Box display="flex" className="positive-percent">
            <ArrowUpwardIcon />
            <p className={isMainCard ? "  main-percent" : " default-percent"}>
              {percentageChange}%
            </p>
          </Box>
        </HtmlTooltip>
      );
    }
    if (percentageChange < 0) {
      return (
        <HtmlTooltip title={percentageDescription} placement="right-start">
          <Box display="flex" className="negative-percent">
            <ArrowDownwardIcon />
            <p className={isMainCard ? "  main-percent" : " default-percent"}>
              {percentageChange}%
            </p>
          </Box>
        </HtmlTooltip>
      );
    }
     // eslint-disable-next-line
      if (percentageChange == 0) {
        return (
        <HtmlTooltip title={percentageDescription} placement="right-start">
        <Box display="flex" className="no-percent">
        <p className={isMainCard ? "  main-percent" : " default-percent"}>
            {percentageChange}%
          </p>
        </Box>
      </HtmlTooltip>)
      }
    else {
      return (
        <HtmlTooltip title={noPercentage} placement="right-start">
          <Box display="flex" className="no-percent">
          <p className={"default-percent"}>
            {percentageChange}
          </p>
          </Box>
        </HtmlTooltip>
      );;
    }
  };
  return (
    <div>
      <div className={isMainCard ? "main-card-row" : ""}>
        <Card
          className={
              program === "Conflict Resolution Program"
              ? "default-card-crp" : "default-card"
          }
        >
          <CardContent>
            <Stack alignItems="center">
              <div className="label-container">
                <p className={"default-label"}>
                  {label}
                </p>
                <HtmlTooltip title={description} placement="right-start">
                  <InfoOutlinedIcon className="info-icon" />
                </HtmlTooltip>
              </div>
              <i className={iconName + (isMainCard ? " fa-3x" : " fa-2x")} />
              <p className={isMainCard ? "main-value" : "default-value"}>
                {formattedValue}
              </p>
              {handlePercentageChange(percentageChange)}
            </Stack>
          </CardContent>
        </Card>
        {isMainCard && (
          <Card className="headline-card">
            <CardContent>
              <p className="headline-title">STAR Dashboard</p>
              <p className="headline-body">
                Welcome to the STAR Dashboard! Here you will find monthly
                updates on key CRP and DP indicators. This Dashboard highlights
                state-level data to give an overview of local trends, focal
                points and other valuable insights.
              </p>
            </CardContent>
          </Card>
        )}
      </div>
    </div>
  );
};

export default IconVisualizationCard;
